module.exports = __webpack_public_path__ + "img/16@2x.095afa1a.png";